<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs v3-portlet">
	<div class="cards-holder devices-tab">
		<div class="card card2 mRight" id="display-creative-v3-chart-container">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div *ngIf="!hasData">
				<img [src]="placeholderimage" class="no-creative-data" />
			</div>

			<div [hidden]="!hasData">
				<div class="c-portlet__header">
					<div class="o-stack__cell">
						<h5 class="creative-charts-header creative-charts-header-with-download">{{ sectiontitle }}</h5>
						<span class="datatable-icon">
							<a
								href="javascript:void(0)"
								class="datatable_download_icon"
								(click)="downloadCSV()"
								target="_blank"
								*ngIf="downloadConfiguration.enableDownload"
							>
								<i class="fa fa-download" aria-hidden="true"></i>
							</a>
						</span>
					</div>
				</div>
				<div class="performance-graph-area" #bubblechartcontainer>
					<div class="legend-area">
						Show data by
						<select (change)="processSelectedLegendItem($event.target.value)">
							<option *ngFor="let legendItem of legend" value="{{ legendItem?.value }}">
								{{ legendItem?.displayName }}
							</option>
						</select>
					</div>
					<app-creative-performance-graph
						[sectiontitle]="sectiontitle"
						[legendData]="legend"
						[chartType]="'areaspline'"
						[seriesName]="selectedLegendName"
						[graphData]="graphData"
						[customLegendData]="customLegendData"
						[enableCustomLegend]="true"
						[legendDisabled]="true"
						[name]="'creative_' + key"
						(legendSelected)="processSelectedLegendItem($event)"
						(mouseOutChart)="chartHover($event)"
						(mouseOverChart)="chartHover($event)"
						[svgHeight]="svgHeight"
						[ticksRotation]="'0'"
						[markerEnabled]="true"
						[showalldatesdata]="showalldatesdata"
						[findRVersion] = "findRVersion"
					></app-creative-performance-graph>
				</div>
			</div>
		</div>
		<div class="card card1 mLeft devices-carousel creative-performance-stats display-creative-container">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div class="display-creative-carousel-item-cntr height-100p" *ngIf="hasData && sortedCreatives">
				<ngu-carousel
					#carousel
					[inputs]="carouselOne"
					(onMove)="onmoveFn($event)"
					(initData)="initDataFn($event)"
					[dataSource]="sortedCreatives"
					class="height-100p"
				>
					<ngu-tile *nguCarouselDef="let creative" NguCarouselItem>
						<div class="r4-carousel">
							<div class="r4-carousel-items">
								<div class="stats-container">
									<div class="title add-color" *ngIf="creative">
										<h5>
											{{ creative?.creativeName }}
										</h5>
										<div>Showing creative {{ activeSlide + 1 }}/{{ sortedCreatives.length }}</div>
										<div class="tooltip">{{ creative?.creativeName }}</div>
									</div>
									<div class="y-scroll-area" *ngIf="creative">
										<div *ngIf="!creative?.isVideoCreative && !creative?.adHeadline" class="creative-thumbnail">
											<div
												class="card-long-img"
												(click)="openModal('display-creative-v4', creative)"
												[ngStyle]="{
													background: 'url(' + creative?.creativeThumbnail + ') no-repeat center center',
													'background-size': getCreativeSize(creative.creativeThumbnail)
												}"
											>
												<div
													class="pill-div"
													[ngClass]="{
														c300x600: creative.creativeThumbnail.includes('300x600'),
														c728x90:
															creative.creativeThumbnail.includes('728x90') ||
															creative.creativeThumbnail.includes('320x50') ||
															creative.creativeThumbnail.includes('300x50') ||
															creative.creativeThumbnail.includes('468x60'),
														c160x600: creative.creativeThumbnail.includes('160x600')
													}"
												>
													<div class="pill primary-color-bg display-pill" *ngIf="creative?.isIAB && !creative.isNative">
														Display
													</div>
													<div class="pill primary-color-bg display-pill" *ngIf="!creative.isIAB && creative?.isNative">
														Native
													</div>
													<div
														class="pill primary-color-bg displaynative-pill"
														*ngIf="creative?.isIAB && creative?.isNative"
													>
														Display with Native
													</div>
												</div>
											</div>
										</div>
										<div class="display-stats-container">
											<ul class="creative-stats display-stats">
												<li>
													<h5 class="stats">{{ creative?.impressions | number }}</h5>
													<span class="stats-label">IMPRESSIONS</span>
												</li>
											</ul>
											<ul class="creative-stats display-stats" *ngIf="creative.isIAB">
												<li *ngIf="!creative?.isVideoCreative">
													<h5 class="stats">{{ creative?.adInteractions | number }}</h5>
													<span class="stats-label">AD INTERACTIONS</span>
												</li>
												<li *ngIf="!creative?.isVideoCreative">
													<h5 class="stats">{{ creative?.adInteractionRate | number: '0.1-2' }}%</h5>
													<span class="stats-label">AD INTERACTION RATE</span>
												</li>
											</ul>
											<ul class="creative-stats display-stats" *ngIf="creative">
												<li class="">
													<h5 class="stats">{{ creative?.clicks | number }}</h5>
													<span class="stats-label">CLICKS</span>
												</li>
												<li *ngIf="creative?.clickRate">
													<h5 class="stats">{{ creative?.clickRate | number: '0.1-2' }}%</h5>
													<span class="stats-label">CLICK RATE</span>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div class="clear"></div>
							</div>
							<div class="clear"></div>
						</div>
					</ngu-tile>

					<span NguCarouselPrev class="leftRs">
						<i class="fa fa-angle-left" aria-hidden="true"></i>
					</span>
					<span NguCarouselNext class="rightRs">
						<i class="fa fa-angle-right" aria-hidden="true"></i>
					</span>
				</ngu-carousel>
			</div>
			<div class="no-data-container" *ngIf="!hasData">
				<div class="map-no-data">No Data to Display</div>
			</div>
		</div>
	</div>
</div>
<app-modal id="display-creative-v4">
	<app-creative-ad-preview
		[creative]="selectedCreative"
		(modalClose)="closeModal('display-creative-v4')"
	></app-creative-ad-preview>
	<div class="modal-background"></div>
</app-modal>
